<div class="col-md-12">
  <app-card [hidHeader]="true" cardClass="card-datatable">
    <form autocomplete="off" [formGroup]="form" (ngSubmit)="validateAll()">
      <!-- Bouton de validation en masse -->
      <div *ngIf="validate && dataSelected.length > 0" class="btn-rental float-right mb-2">
        <button (click)="validateAll()" type="button" class="btn btn-success m-1">
          Valider sélectionnées <i class="feather icon-check-square"></i>
        </button>
      </div>

      <!-- Loader -->
      <div *ngIf="loading" class="text-center py-3">
        <i class="fas fa-spinner fa-spin"></i> Chargement des transactions...
      </div>

      <!-- Message si aucune transaction -->
      <div *ngIf="!loading && transactions.length === 0" class="text-center py-4">
        <p class="text-muted">Aucune transaction wallet trouvée</p>
      </div>

      <!-- Tableau des transactions -->
      <div class="table-responsive" *ngIf="!loading && transactions.length > 0">
        <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
          <thead class="thead-light">
            <tr>
              <th *ngIf="validate">
                <div class="form-group">
                  <div class="form-check">
                    <input id="checkAll" class="form-check-input" formControlName="valueOne" type="checkbox"
                      (change)="onCheckAll($event)">
                  </div>
                </div>
              </th>
              <th>Référence</th>
              <th>Type</th>
              <th>Libellé</th>
              <th>Date</th>
              <th>Montant</th>
              <th>État</th>
              <th>Créé le</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let transaction of transactions; let i = index">
              <td *ngIf="validate">
                <div class="form-group">
                  <div class="form-check">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      id="check{{i}}"
                      [disabled]="transaction.etat !== 'ATTENTE'"
                      (change)="onCheckItem(transaction)">
                  </div>
                </div>
              </td>
              <td>
                <p class="m-0 font-16">
                  <span class="text-dark font-weight-bold">{{transaction.code || transaction.reference}}</span>
                </p>
              </td>
              <td>
                <span class="badge" [ngClass]="getTypeBadgeClass(transaction.type || '')">
                  {{getTypeLabel(transaction.type || '')}}
                </span>
                <span *ngIf="isFromPayment(transaction)" class="badge badge-dark ml-1" ngbTooltip="Transaction issue d'un paiement client">
                  <i class="fas fa-money-bill-wave mr-1"></i>Paiement
                </span>
              </td>
              <td>
                <p class="m-0 font-14 text-muted" [title]="transaction.libelle">
                  {{transaction.libelle || '-'}}
                </p>
              </td>
              <td>{{transaction.date | date: "d MMMM y" : '' : 'fr-FR'}}</td>
              <td>
                <span class="font-weight-bold"
                      [ngClass]="{
                        'text-success': isTypeCredit(transaction.type),
                        'text-danger': !isTypeCredit(transaction.type)
                      }">
                  {{isTypeCredit(transaction.type) ? '+' : '-'}}{{formatMontant(transaction.montant || 0)}}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="getEtatBadgeClass(transaction.etat || '')">
                  {{validation(transaction.etat || '')}}
                </span>
              </td>
              <td>{{transaction.createdAt | date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR'}}</td>
              <td class="table-action">
                <div class="overlay-edit">
                  <button (click)="showTransaction(transaction)" type="button" class="btn btn-icon btn-secondary"
                    ngbTooltip="Détails">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button 
                    (click)="printReceipt(transaction)" 
                    type="button" 
                    class="btn btn-icon btn-info ml-1" 
                    ngbTooltip="Imprimer le reçu">
                    <i class="fas fa-print"></i>
                  </button>
                  <button 
                    *ngIf="transaction.etat !== 'VALIDE' && transaction.etat !== 'ANNULE'"
                    (click)="editTransaction(transaction)" 
                    type="button" 
                    class="btn btn-icon btn-primary ml-1"
                    ngbTooltip="Modifier">
                    <i class="feather icon-edit-2"></i>
                  </button>
                  <button 
                    *ngIf="transaction.etat === 'ATTENTE' && validate" 
                    (click)="validateTransaction(transaction)" 
                    type="button" 
                    class="btn btn-icon btn-success ml-1" 
                    ngbTooltip="Valider">
                    <i class="fas fa-check"></i>
                  </button>
                  <button 
                    *ngIf="transaction.etat !== 'ANNULE'"
                    (click)="cancelTransaction(transaction)" 
                    type="button" 
                    class="btn btn-icon btn-danger ml-1" 
                    ngbTooltip="Annuler">
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot *ngIf="transactions.length > 0">
            <tr>
              <td [attr.colspan]="validate ? '7' : '6'" class="font-weight-bold font-size-40 text-right">TOTAL</td>
              <td class="font-weight-bold font-size-40 text-success">
                {{formatMontant(total)}}
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </form>
  </app-card>
</div>

